import api from '../utils/api';

const WA_NUMBER = '918595675155';

function buildWhatsAppUrl(payload) {
  const lines = [
    'Hi BookMyLibrary team, I want to list my library.',
    '',
    `Owner: ${payload.ownerName}`,
    `Phone: +91${payload.phone}`,
    `Email: ${payload.email}`,
    `Library: ${payload.libraryName}`,
    `City: ${payload.city}`,
    `Seats: ${payload.seats}`,
    `Current system: ${payload.currentSystem}`,
    payload.wantsWebsite ? 'Add-on: Library website (₹1,999/year)' : null,
    payload.message ? `Notes: ${payload.message}` : null,
  ]
    .filter(Boolean)
    .join('\n');
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(lines)}`;
}

export async function submitLibraryLead(payload) {
  const body = { ...payload, source: 'join-us-as-library' };
  try {
    const res = await api.post('/marketing/library-leads', body);
    if (res?.data && res.data.error === false) {
      return { ok: true, data: res.data.data };
    }
    throw new Error('Unexpected response');
  } catch (err) {
    try {
      window.open(buildWhatsAppUrl(payload), '_blank', 'noopener,noreferrer');
    } catch (_) {
      /* ignore popup failures */
    }
    return { ok: false, fallback: 'whatsapp' };
  }
}
